import { z } from 'zod';
const linkPageCopySchema = z.object({ ar: z.string().trim().max(60).default(''), en: z.string().trim().max(60).default('') });
export const linkPageOptionsSchema = z.object({
    accentColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().default(null),
    bookingMode: z.enum(['auto', 'none', 'services', 'duration', 'schedule', 'guests']).default('auto'),
    bookingLabel: linkPageCopySchema.default({ ar: '', en: '' }),
    bookingHeading: linkPageCopySchema.default({ ar: '', en: '' }),
    serviceIds: z.array(z.uuid()).max(6).refine((ids) => new Set(ids).size === ids.length).default([]),
    galleryFileIds: z.array(z.uuid()).max(3).refine((ids) => new Set(ids).size === ids.length).default([]),
});
export const defaultLinkPageOptions = linkPageOptionsSchema.parse({});
//# sourceMappingURL=link-page-options.js.map